import { slugify } from "@shared/lib/slugify";
import type { Store } from "@/lib/types/stores";

export function getStoreSlug(store: Pick<Store, "name">): string {
  return slugify(store.name) || "store";
}

export function getStorePath(store: Pick<Store, "name">): string {
  return `/stores/${getStoreSlug(store)}`;
}
